import type { AppContextType } from "@/types/context-type";
import { createContext, type Dispatch, type SetStateAction } from "react";

export const AppContext = createContext<{
    app: AppContextType | null;
    setApp: Dispatch<SetStateAction<AppContextType | null>>;
}>({
    app: null,
    setApp: () => null,
});
